import { Box, Grid, ListItem, ListItemText, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core/styles';
import { useStore } from '@roc/client-portal-shared/hooks';
import { Button, ConfirmDialog, Paper, StandardDialog } from '@roc/ui';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { createCurrencyField, createPercentageField } from '../../../components/formComponents/common/componentBuilder';
import AddPricingEconomicsTierDialog from '../components/originatorPricingEconomics/addPricingEconomicsTierDialog';
import AddPricingEconomicsTier from '../components/originatorPricingEconomics/pricingEconomicsStepper';
import { TierPricingEconomicsTable } from '../components/originatorPricingEconomics/tierPricingEconomicsTable';

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(2),
  },
}));

export const Economics = observer(({ companyProfileStore }) => {
  const formStore = companyProfileStore.lenderFeesFormStore;
  const lenderFormStore = companyProfileStore.salesforceLenderStore;
  const isEditing = formStore.isEditing;

  const classes = useStyles();
  const [selectedTab, setSelectedTab] = useState(false);

  useEffect(() => {
    formStore.loadLenderFees();
    companyProfileStore.lenderTermTierEconomicsFormStore.getAllTermTiers()
  }, []);

  return (
    <>
      <Paper className={classes.paper}>
        {formStore.lenderFees && (
          <Box p={4}>
            <Grid container spacing={4}>
              <Grid item xs={12} container>
                <Grid item xs={6}>
                  <Typography variant="h5">Borrower Economics</Typography>
                </Grid>
                <Grid item xs={6} container justifyContent="flex-end">
                  {isEditing ? (
                    <>
                      <Button
                        style={{ marginRight: '8px' }}
                        onClick={() => formStore.cancel()}
                        color="primary"
                        variant="outlined"
                        testId="cancel"
                      >
                        Cancel
                      </Button>
                      <Button
                        onClick={() => formStore.saveLenderFees()}
                        color="primary"
                        variant="contained"
                        testId="save"
                      >
                        Apply Changes
                      </Button>
                    </>
                  ) : (
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={() => formStore.edit()}
                      testId="save"
                    >
                      Edit
                    </Button>
                  )}
                </Grid>
              </Grid>

              <Grid item xs={12} md={6}>
                {createCurrencyField({
                  testId: 'economics-admin-fees',
                  label: 'Admin Fees',
                  fieldName: 'adminFees',
                  store: formStore,
                  disabled: !isEditing,
                })}
              </Grid>
              <Grid item xs={12} md={6}>
                {createCurrencyField({
                  testId: 'economics-commitment-fees',
                  label: 'Commitment Fees',
                  fieldName: 'commitmentFees',
                  store: formStore,
                  disabled: !isEditing,
                })}
              </Grid>
              <Grid item xs={12} md={6}>
                {createCurrencyField({
                  testId: 'economics-processing-fees',
                  label: 'Processing Fees',
                  fieldName: 'processingFees',
                  store: formStore,
                  disabled: !isEditing,
                })}
              </Grid>
              <Grid item xs={12} md={6}>
                {createCurrencyField({
                  testId: 'economics-underwriting-fees',
                  label: 'Underwriting Fees',
                  fieldName: 'underWritingFees',
                  store: formStore,
                  disabled: !isEditing,
                })}
              </Grid>
              <Grid item xs={12} md={6}>
                {createPercentageField({
                  testId: 'economics-default-term-points',
                  label: 'Term Origination Points',
                  fieldName: 'defaultTermPoints',
                  store: formStore,
                  disabled: !isEditing,
                })}
              </Grid>
            </Grid>
          </Box>
        )}
      </Paper>
      <Paper className={classes.paper}>
        <Box p={4}>
          <Grid container spacing={4}>
            <Grid item xs={12} container>
              <Grid item xs={6}>
                <Typography variant="h5">Tier Term Economics</Typography>
              </Grid>
              <Grid item container xs={6} justifyContent='flex-end'>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => {
                    companyProfileStore.lenderTermTierEconomicsFormStore.resetBorrowers()
                    companyProfileStore.lenderTermTierEconomicsFormStore.setGetAllBorrowers(true)
                    setSelectedTab(true)
                  }}
                  testId="save">
                  + Tier/Borrower
                </Button>
              </Grid>
            </Grid>
            <Grid item xs={12} container>
              <TierPricingEconomicsTable companyProfileStore={companyProfileStore} emptyMessage='- Empty -' />
            </Grid>
          </Grid>
        </Box>
      </Paper>
      <AddPricingEconomicsTierDialog
        open={selectedTab}
        title=''
        handleClose={() => { setSelectedTab(false) }}
        companyProfileStore={companyProfileStore} />
    </>
  );
});
